import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import { Route } from 'react-router'
import ChuFormProvider from '../common/components/chu-form-provider';
import LandingRootComponent from './landing-root-component';
import ContentsRootComponent from '../contents/contents-root-component';
import LandlordsRootComponent from '../landlords/landlords-root-component';
import StrataRootComponent from '../strata/strata-root-component';
import config from './config'
import reducers from './reducer-map'
import '../common/common-styles.css'


// We prevent the Redux dev tools for this project, because the individual forms need
// to make use of it.

// Google tag Manager script
(function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
        'gtm.start':
            new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
        j:any = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-T4JHGML');



    
    
    class GAComponent extends React.Component<any,any> {
        constructor(props) {
            super(props);
          }
          
        iframe (props) {
          return {
            __html: props.iframe
          }
        }
      
        render () {
            // window.addEventListener("hashchange", e => console.log('hashchange', window.location.hash));
          return (
            <div>
              <div dangerouslySetInnerHTML={ this.iframe(this.props) } />
            </div>
          );
        }
      }
   
      const iframe = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-T4JHGML" height="0" width="0" style="display:none;visibility:hidden"></iframe>'; 
    

ReactDOM.render(
    
    <div>
    <GAComponent iframe={iframe} />
    <ChuFormProvider reducers={ reducers } preventReduxDevTools>
        <BrowserRouter>
            <div>
                <Route path="/contents/" component={ ContentsRootComponent } />  
                <Route path="/landlords/" component={ LandlordsRootComponent } />  
                <Route path="/strata/" component={ StrataRootComponent } />  
                <Route exact path="/" component={ LandingRootComponent } />  
            </div>
        </BrowserRouter>
    </ChuFormProvider>
    </div>
    
, document.getElementById('root'));


if (module["hot"]) {
    module["hot"].accept()
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/index.tsx